import { render, staticRenderFns } from "./AlarmTable.vue?vue&type=template&id=85b987f6&scoped=true"
import script from "./AlarmTable.vue?vue&type=script&lang=js"
export * from "./AlarmTable.vue?vue&type=script&lang=js"
import style0 from "./AlarmTable.vue?vue&type=style&index=0&id=85b987f6&prod&scoped=true&lang=css"
import style1 from "./AlarmTable.vue?vue&type=style&index=1&id=85b987f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b987f6",
  null
  
)

export default component.exports